import { IBalanceOper } from '../redux/debug';
import { Api } from './api';

export class DebugApi {
    private static readonly PATH = '/debug';

    constructor(private readonly m_api: Api) {}

    public async exportBalanceOperation(operation: IBalanceOper) {
        return this.m_api.post(`${DebugApi.PATH}/export-balance-operation`, { operation });
    }
}